/* External */
import { createContext } from 'react';

/* Utils */
import { noOp } from '../../utils/functions';

export const UserAccountContext = createContext(undefined);
export const UserAccountLoadingContext = createContext(false);
export const UserCustomDataContext = createContext(undefined);
export const UserCustomDataUpdatingContext = createContext(false);
export const UpdateUserCustomDataContext = createContext(noOp);
